export const APP_VERSION = import.meta.env.PACKAGE_VERSION;
export const DISCORD_LINK = "https://discord.com/users/1141729666160402565";
export const GITHUB_LINK = "https://github.com/rishabnotfound/rezeplayer";
// export const GA_ID = import.meta.env.VITE_GA_ID;
// export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;